{
  "title": "Manage External Wallets",
  "subtitle": "Connect your external wallet below and manage your transactions",
  "sections": {
    "transactions": {
      "title": "Transactions"
    },
    "wallet": {
      "title": "Wallet Information",
      "items": {
        "address": "Address",
        "chain": "Blockchain",
        "key": "Key"
      },
      "connect": "Connect your wallet to start"
    }
  },
  "status": {
    "pending": "Your account are missing additional information to use external wallet services. Please go to user panel and update your application.",
    "created": "Your account is under review. Please wait for the approval to use external wallet services.",
    "rejected": "Your account is not able to use external wallet services. Please contact support for more information."
  }
}
